import { useEffect, useState } from 'react'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import styled from 'styled-components'
import Page5MobileContents from './components/Page5MobileContents'
import PopUp2Mobile from "../../components/PopUp2Mobile";
function Page5Mobile(prop) {
  const goods = prop.goods
  const [selectedGoods, setSelectedGoods] = useState()

  useEffect(() => {
    setSelectedGoods(goods[0])
  }, [goods])


  
  const [showPopUpUrl, setShowPopUp] = useState(null);
  const close = () => {
    setShowPopUp(null);
  };
	const [moved, setMoved] = useState(false);
	const downListener = () => {
		setMoved(false);
  }
	const moveListener = () => {
  	setMoved(true);
	}
  const upListener = (url, idx) => {
    console.log(url);
    if (moved) {
        if(url === 'videoM'){
          const video = document.querySelector("#videoM"+idx);
          video.pause();
          video.currentTime = 0;
        }
    } else {
        if(url !== 'videoM')
          setShowPopUp(url);
    }
  }

  return (
    <>
    {showPopUpUrl ? <PopUp2Mobile img={showPopUpUrl} close={close} /> : null}
    <MainContainer>
      <Top>
        {goods &&
          selectedGoods &&
          goods.map((gs) => {
            return (
              <TopText
                selected={selectedGoods.gsSeq == gs.gsSeq}
                key={gs.gsSeq}
                onClick={() => {
                  setSelectedGoods(gs)
                }}
              >
                {gs.gsName}
              </TopText>
            )
          })}
      </Top>
      {selectedGoods && <Page5MobileContents selectedGoods={selectedGoods}  downListener={downListener} moveListener={moveListener} upListener={upListener}/>}
    </MainContainer>
    </>
  )
}

export default Page5Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 60.7px;
  background: #f8f8f8;
`
const Top = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  width: 100%;
  height: 44.3px;
  padding: 0 20px;
  box-sizing: border-box;
  background: #1f1f1b;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`
const TopText = styled.p`
  flex: 0 0 auto;
  white-space: nowrap;
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 13.3px;
  color: ${(props) => (props.selected ? '#A29780' : '#B9B9B9')};
`
